<template>
    <div class="coefficients">
        <div class="row mb-5">
            <div class="col-12">
                <div class="table-responsive mb-3">
                    <table class="table realty-table">
                        <thead>
                        <th></th>
                        <th class="realty-table__th-left text-uppercase">{{ $t('coefficients.valued') }}</th>
                        <th></th>
                        <th class="realty-table__th-right text-uppercase">{{ $t('coefficients.comparable') }}</th>
                        </thead>

                        <tbody>
                        <tr v-for="(coefficient, key) in this.multiColCoefs">
                            <th class="align-middle" >{{ coefficient.desc }}</th>
                            <td :class="coefficient.overflow ? 'overflowing' : ''" class="realty-table__td-left align-middle">
                                <div class="custom-card" data-toggle="tooltip" data-html="true" :title="coefficient.calc">
                                    <span v-if="coefficient.calc"><span v-html="coefficient.calc"></span></span>
                                    <div v-else>
                                        <div class="form-group mb-0">
                                            <input
                                                type="text"
                                                id=""
                                                :name="coefficient.key + '_addition_calc_desc'"
                                                v-model="coefficient.addition_calc_desc"
                                                placeholder=""
                                                class="form-control border-radius-20"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td class="align-middle">
                                <div class="btn-group">
                                    <div v-on:click="coefficient.state = false"
                                         class="btn btn-secondary btn-left" :class="'state' + (coefficient.state === false ? ' active' : '')"
                                         data-toggle="tooltip"
                                         data-placement="top" data-html="true" :title="$t('coefficients.title_valued')">
                                        <i class="fas fa-arrow-left mr-1"></i>
                                        {{ $t('coefficients.better') }}
                                    </div>
                                    <div v-on:click="coefficient.state = null"
                                        class="btn btn-secondary" :class="'state' + (coefficient.state === null ? ' active' : '')">
                                        {{ $t('coefficients.same') }}
                                    </div>
                                    <div v-on:click="coefficient.state = true"
                                        class="btn btn-secondary btn-right" :class="'state' + (coefficient.state === true ? ' active' : '')"
                                         data-toggle="tooltip"
                                         data-placement="top" data-html="true" :title="$t('coefficients.title_comparable')">
                                        {{ $t('coefficients.better') }}
                                        <i class="fas fa-arrow-right ml-1"></i>
                                    </div>
                                </div>

                                <div v-if="coefficient.state !== null" class="price">
                                    <p class="custom-prepend">{{ $t('coefficients.difference')}}:</p>
                                    <div class="custom-minus">{{ coefficient.state ? '-' : '+'}}</div>
                                    <div class="input-group">
                                        <div class="input-wrapper" v-if="coefficient.input_type === 'percent'" >
                                            <input class="form-control" :name="coefficient.key" type="number"
                                                   v-model="coefficient.coef" :data-key="coefficient.index" v-on:blur="updateState"
                                                   min="0" max="100">
                                        </div>
                                        <div class="input-wrapper" v-else>
                                            <input class="form-control" :name="coefficient.key + '-price'" type="number" step="1"
                                                   v-model="coefficient.price_abs" :data-key="coefficient.index" v-on:blur="updateState"
                                                   min="0">
                                            <input :name="coefficient.key" type="hidden" v-model="coefficient.coef">
                                        </div>

                                        <div class="input-group-append">
                                            <i class="fas fa-angle-down"></i>
                                            <i class="fas fa-angle-down"></i>
                                            <select v-model="coefficient.input_type">
                                                <option value="czk">Kč</option>
                                                <option value="percent">%</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <input :name="coefficient.key" type="hidden" value="0">
                                </div>
                                <!--<small class="coef-price no-wrap">
                                    tj. {{ coefficient.state ? '-' : '+'}}
                                    {{ formatPrice((coefficient.coef/100) * origin.price) }} Kč
                                </small>-->
                            </td>
                            <td :class="coefficient.overflow ? 'overflowing' : ''" class="realty-table__td-right align-middle">
                                <div class="custom-card" data-toggle="tooltip" data-html="true" :title="coefficient.realty">
                                    <span v-if="coefficient.realty"><span v-html="coefficient.realty"></span></span>
                                    <div v-else>
                                        <div class="form-group mb-0">
                                            <input
                                                type="text"
                                                id=""
                                                :name="coefficient.key + '_addition_realty_desc'"
                                                v-model="coefficient.addition_realty_desc"
                                                placeholder=""
                                                class="form-control border-radius-20"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <!--  Example of new table row  -->
                        <tr v-for="(coefficient, key) in this.customColCoefs">
                            <th class="align-middle">
                                <div class="d-flex align-items-center">
                                    <a href="#" v-on:click.stop.prevent="deleteCustomCoef(coefficient.index)" :title="$t('coefficients.delete_custom_coef')"><i class="fas fa-times mr-2 text-danger font-2xl"></i></a>
                                    <div class="form-group mb-0"><input
                                        type="text"
                                        id=""
                                        :name="coefficient.key + '_addition_desc'"
                                        v-model="coefficient.addition_desc"
                                        placeholder=""
                                        value=""
                                        class="form-control border-radius-20"
                                    >
                                    </div>
                                </div>
                            </th>
                            <td class="realty-table__td-left align-middle">
                                <div data-toggle="tooltip" data-html="true" class="custom-card"
                                     data-original-title="">
                                    <div>
                                        <div class="form-group mb-0"><input
                                            type="text"
                                            id=""
                                            :name="coefficient.key + '_addition_calc_desc'"
                                            v-model="coefficient.addition_calc_desc"
                                            placeholder=""
                                            class="form-control border-radius-20"
                                        >
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="align-middle">
                                <div class="btn-group">
                                    <div v-on:click="coefficient.state = false"
                                         class="btn btn-secondary btn-left" :class="'state' + (coefficient.state === false ? ' active' : '')"
                                         data-toggle="tooltip"
                                         data-placement="top" data-html="true" :title="$t('coefficients.title_valued')">
                                        <i class="fas fa-arrow-left mr-1"></i>
                                        {{ $t('coefficients.better') }}
                                    </div>
                                    <div v-on:click="coefficient.state = null"
                                         class="btn btn-secondary" :class="'state' + (coefficient.state === null ? ' active' : '')">
                                        {{ $t('coefficients.same') }}
                                    </div>
                                    <div v-on:click="coefficient.state = true"
                                         class="btn btn-secondary btn-right" :class="'state' + (coefficient.state === true ? ' active' : '')"
                                         data-toggle="tooltip"
                                         data-placement="top" data-html="true" :title="$t('coefficients.title_comparable')">
                                        {{ $t('coefficients.better') }}
                                        <i class="fas fa-arrow-right ml-1"></i>
                                    </div>
                                </div>

                                <div v-if="coefficient.state !== null" class="price">
                                    <p class="custom-prepend">{{ $t('coefficients.difference') }}:</p>
                                    <div class="custom-minus">{{ coefficient.state ? '-' : '+'}}</div>
                                    <div class="input-group">
                                        <div class="input-wrapper" v-if="coefficient.input_type === 'percent'" >
                                            <input class="form-control" :name="coefficient.key" type="number"
                                                   v-model="coefficient.coef" :data-key="coefficient.index" v-on:blur="updateState"
                                                   min="0" max="100">
                                        </div>
                                        <div class="input-wrapper" v-else>
                                            <input class="form-control" :name="coefficient.key + '-price'" type="number" step="1"
                                                   v-model="coefficient.price_abs" :data-key="coefficient.index" v-on:blur="updateState"
                                                   min="0">
                                            <input :name="coefficient.key" type="hidden" v-model="coefficient.coef">
                                        </div>

                                        <div class="input-group-append">
                                            <i class="fas fa-angle-down"></i>
                                            <i class="fas fa-angle-down"></i>
                                            <select v-model="coefficient.input_type">
                                                <option value="czk">Kč</option>
                                                <option value="percent">%</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <input :name="coefficient.key" type="hidden" value="0">
                                </div>
                                <!--<small class="coef-price no-wrap">
                                    tj. {{ coefficient.state ? '-' : '+'}}
                                    {{ formatPrice((coefficient.coef/100) * origin.price) }} Kč
                                </small>-->
                            </td>
                            <td class="realty-table__td-right align-middle">
                                <div data-toggle="tooltip" data-html="true" class="custom-card"
                                     data-original-title="">
                                    <div>
                                        <div class="form-group mb-0"><input
                                            type="text"
                                            id=""
                                            :name="coefficient.key + '_addition_realty_desc'"
                                            v-model="coefficient.addition_realty_desc"
                                            placeholder=""
                                            class="form-control border-radius-20"
                                        >
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <!-- // Example of new table row  -->

                        </tbody>
                    </table>
                </div>

                <div class="text-center" v-if="isAllowedCustomCoef && canAddItem">
                    <button v-on:click.stop.prevent="createCustomCoef"  class="btn btn-secondary">
                        <i class="fas fa-plus mr-1"></i>
                        {{ $t('coefficients.create_custom_coef') }}
                    </button>
                </div>

            </div>
        </div>
        <h2 class="text-left mb-3">{{ $t('coefficients.edit_advertised_price')}}</h2>
        <div class="row justify-content-md-center">
            <div v-for="(coefficient, key) in this.oneColCoefs" class="col-md-6 mb-3">
                <div class="card border-0 mb-4 mb-md-0">
                    <div class="card-body">
                        <div class="text-left">
                            <h5>{{ coefficient.desc }}</h5>
                            <p v-html="coefficient.realty"></p>
                        </div>
                        <div class="input-group w-75 mx-auto">
                            <div class="input-group-prepend">
                                <select v-model="coefficient.state"
                                        class="custom-select border-radius-0-right bg-blue" :disabled="['sale_price_difference', 'sale_price_is_cadastre'].includes(coefficient.key)">
                                    <option value="true">-</option>
                                    <option value="false">+</option>
                                </select>
                            </div>
                            <input v-if="coefficient.input_type === 'percent'"
                                   class="form-control text-center" :name="coefficient.key" type="number"
                                   v-model="coefficient.coef" :data-key="coefficient.index" v-on:blur="updateState"
                                   min="0" max="100" :disabled="['sale_price_difference', 'sale_price_is_cadastre'].includes(coefficient.key)">

                            <input v-else-if="coefficient.input_type === 'unit'" class="form-control text-center" :name="coefficient.key + '-price'" type="number" step="1"
                                   v-model="coefficient.price_abs" :data-key="coefficient.index" v-on:blur="updateState"
                                   min="0" :disabled="['sale_price_difference', 'sale_price_is_cadastre'].includes(coefficient.key)">
                            <input v-else-if="coefficient.input_type === 'unit'" :name="coefficient.key" type="hidden" v-model="coefficient.coef" :disabled="['sale_price_difference', 'sale_price_is_cadastre'].includes(coefficient.key)">
                            <div class="input-group-append">
                                <select v-model="coefficient.input_type"
                                        class="custom-select border-radius-0-left bg-blue" :disabled="['sale_price_difference', 'sale_price_is_cadastre'].includes(coefficient.key)">
                                    <option value="unit">Kč</option>
                                    <option value="percent">%</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="summary">
            <div class="container-xl">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="summary__fixed-box shadow-sm">
                            <div class="row">
                                <div class="col-6 col-md-4 d-none d-md-block">
                                    <h3>{{ $t('coefficients.original_price')}}</h3>
                                    <h1><span id="original-price-coef">{{ this.originalPrice }}</span> Kč</h1>
                                    <h2 class="mb-0">(<span
                                        id="original-price-m2-coef">{{ this.originalPriceM }}</span> Kč/m<sup>2</sup>)
                                    </h2>
                                </div>
                                <div class="col-6 col-md-4">
                                    <h3>{{ $t('coefficients.final_price')}}</h3>
                                    <h1><span id="custom-coef-coef">{{ this.customDisplayCoef }}</span> %</h1>
                                    <h2 class="mb-0">(tj. <span id="custom-diff-coef">{{ this.customDiffCoefFormatted }}</span> Kč)
                                    </h2>
                                </div>
                                <div class="col-6 col-md-4">
                                    <h3>{{ $t('coefficients.edit_price')}}</h3>
                                    <h1><span id="custom-price-coef">{{ this.customPriceFormatted }}</span> Kč</h1>
                                    <h2 class="mb-0">(<span
                                        id="custom-price-m2-coef">{{ this.customPriceMFormatted }}</span> Kč/m<sup>2</sup>)
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <input type="hidden" :id="'custom_coef_' + this.recordId" :name="'custom_coef_' + this.recordId" v-model="customCalcCoef">
            <input type="hidden" :id="'coef_print_' + this.recordId" :name="'coef_print_' + this.recordId" v-model="customCalcCoefPrint">
            <input type="hidden" :id="'coef_json_' + this.recordId" :name="'coef_json_' + this.recordId" v-model="customCoefJson">
        </div>
    </div>
</template>

<script>
    export default {
        name: "coefficients",

        props: ['coefficients', 'customCoefs', 'defaultData', 'recordId', 'priceDifference', 'isAllowedCustomCoef'],

        data: function() {
            return {
                coefs: [],
                copy: [],
                origin: [],
                canAddItem: true,
            }
        },

        computed: {
            originalPrice: function () {
                return addSpaces(this.origin.price);
            },

            originalPriceM: function () {
                return addSpaces(this.origin.priceM);
            },

            customCoef: function () {
                /*let coefs = this.getCoefValues(false)

                return coefs.reduce(
                    (sum, item) =>
                        parseFloat(sum) + ((isNaN(parseFloat(item.value))) ? 0 : (parseFloat(item.value)))
                    , 0
                );*/

                let customCoef = 1;
                this.getCoefValues(false).forEach(function (item) {
                    customCoef *= ((item.value/100) + 1)
                })

                return (customCoef * 100) - 100
            },

            customDisplayCoef: function () {
                return this.customCoef.toFixed(2)
            },

            customCalcCoef: function () {
                return (1 + parseFloat(this.customCoef/100)) * this.priceDifference;
            },

            customCalcCoefPrint: function () {
                return (1 + parseFloat(this.customCoef/100));
            },

            customDiffCoef: function () {
                return this.customPrice - this.origin.price;
            },

            customCoefJson: function () {
                return JSON.stringify(this.getCoefValues(true));
            },

            customDiffCoefFormatted: function () {
                return addSpaces((this.customDiffCoef).toFixed(0));
            },

            customPrice: function () {
                let customPrice = this.origin.price
                this.getCoefValues(false).forEach(function (item) {
                    customPrice *= ((item.value/100) + 1)
                })

                return customPrice
            },

            customPriceFormatted: function () {
                return addSpaces((this.customPrice).toFixed(0));
            },

            customPriceM: function () {
                let customPriceM = this.origin.priceM
                this.getCoefValues(false).forEach(function (item) {
                    customPriceM *= ((item.value/100) + 1)
                })

                return customPriceM
            },

            customPriceMFormatted: function () {
                return addSpaces((this.customPriceM).toFixed(0));
            },

            getWithOriginalIndex: function () {
                let coefsWithIndex = [];

                for (let i = 0; i < this.coefs.length; i++) {
                    coefsWithIndex[i] = this.coefs[i]
                    coefsWithIndex[i].index = i
                }

                return coefsWithIndex
            },

            oneColCoefs: function () {
                return this.getWithOriginalIndex.filter(i => i.one_col === true && i.custom_col === false)
            },

            multiColCoefs: function () {
                return this.getWithOriginalIndex.filter(i => (i.one_col === false && i.custom_col === false))
            },

            customColCoefs: function () {
                return this.getWithOriginalIndex.filter(i => i.custom_col === true)
            }
        },

        methods: {
            formatPrice: function (price) {
                return addSpaces(price.toFixed(0));
            },

            getCoefValues: function (keys) {
                var coefValues = [];
                for(var i = 0; i < this.coefs.length; i++) {
                    var selected = this.coefs[i];
                    var key = keys ? selected.key : "value";
                    var coef = selected.coef;
                    var item = {};

                    if (selected.state === null) {
                        item[key] = parseFloat(0);
                    } else {
                        item[key] = String(selected.state) == "true" ? parseFloat(-coef) : parseFloat(coef);
                    }
                    if (selected.addition_calc_desc !== null) {
                        item['addition_calc_desc'] = selected.addition_calc_desc;
                    }
                    if (selected.addition_realty_desc !== null) {
                        item['addition_realty_desc'] = selected.addition_realty_desc;
                    }

                    if (selected.addition_desc !== null) {
                        item['addition_desc'] = selected.addition_desc;
                    }

                    coefValues.push(item);
                }

                return coefValues;
            },

            updateState: function (e) {
                let coefficient = this.coefs[e.target.dataset.key]

                if (!coefficient.one_col) {
                    if (coefficient.coef == 0 || coefficient.price_abs == 0) {
                        this.coefs[e.target.dataset.key].state = null
                    }
                }
            },

            createCustomCoef: function() {
                let defaultCustomCoef = {
                    addition_calc_desc: null,
                    addition_desc: null,
                    addition_realty_desc: null,
                    calc: null,
                    coef: 0,
                    custom_col: true,
                    desc: null,
                    escape_calc: false,
                    escape_realty: false,
                    index: this.coefs.length,
                    input_type: "percent",
                    key: "custom",
                    one_col: false,
                    overflow: false,
                    price: "0",
                    price_abs: 0,
                    realty: null,
                    state: null,
                }

                this.coefs.splice(defaultCustomCoef.index, 0, defaultCustomCoef);
                this.copy = JSON.stringify(this.coefs)
                this.canAddItem = false;
            },

            deleteCustomCoef: function (key) {
                this.coefs.splice(key, 1);

                this.copy = JSON.stringify(this.coefs)
                this.canAddItem = true;
            },

        },

        watch: {
            coefs: {
                deep: true,

                handler: function(value, old) {
                    if (old.length > 0) {
                        let copy = JSON.parse(this.copy)

                        for (let i in value) {
                            if (value[i].coef < 0) {
                                value[i].coef = 0
                            } else if (value[i].price_abs < 0) {
                                value[i].price_abs = 0
                            }

                            if (value[i].coef !== copy[i].coef) {
                                this.coefs[i].price_abs = ((value[i].coef/100) * this.origin.price).toFixed(0)
                            } else if (value[i].price_abs !== copy[i].price_abs) {
                                this.coefs[i].coef = parseInt(((value[i].price_abs / this.origin.price) * 100))
                            }
                        }

                        this.copy = JSON.stringify(this.coefs)
                    }
                }

            }
        },

        created: function () {
            this.coefs = JSON.parse(this.coefficients);
            this.origin = JSON.parse(this.defaultData);

            var customCoefs = JSON.parse(this.customCoefs);
            var custom = {};
            for (var i in customCoefs) {
                var item = customCoefs[i];
                for(var key in item){
                    custom[key] = item[key];
                }
            }

            for (i in this.coefs) {
                if (custom[this.coefs[i].key]/* && custom[this.coefs[i].key] != 0*/) {
                    this.coefs[i].state = custom[this.coefs[i].key] < 0
                    this.coefs[i].coef = parseInt(Math.abs(custom[this.coefs[i].key]))
                } else {
                    this.coefs[i].coef = parseInt(this.coefs[i].coef)
                }

                if (!this.coefs[i].one_col) {
                    this.coefs[i].state = this.coefs[i].coef == 0 ? null : this.coefs[i].state
                }
                this.coefs[i].price_abs = this.coefs[i].coef/100 * this.origin.price
            }

            this.copy = JSON.stringify(this.coefs)
        },
    }
</script>

<style scoped>
    .state-switch:hover {
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .overflowing {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 125px;
        cursor: help;
    }

    .coef-price {
        white-space: nowrap;
        overflow: visible;
    }

    .no-wrap {
        white-space: nowrap;
    }
</style>
